import React, { useEffect, useState } from "react";
import HomeHead from "../Header/HomeHead";
import HomeBody from "../../pages/HomeBody";
import HomeFooter from "../Footer/HomeFooter";

import Spinner from "../Loading&Spinners/Spinner";
import WhatsAppButton from "../CustomerSupport/WhatsAppButton";

const Home = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay with setTimeout
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 50); // Adjust the delay as needed

    // Clean up the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className={`App ${loading ? "loading" : ""}`}>
      {loading && <Spinner />}
      <html lang="en">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta http-equiv="X-UA-Compatible" content="ie=edge" />
          <meta name="forntEnd-Developer" content="Saad & Muzammil" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <title>GameNow</title>
          <link
            rel="shortcut icon"
            href="assets/images/favicon.png"
            type="image/x-icon"
          />
          <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
          <link rel="stylesheet" href="assets/css/plugin.css" />
          <link rel="stylesheet" href="assets/css/style.css" />
        </head>
        <body>
          <HomeHead />
          {!loading && <HomeBody />}

          <HomeFooter />
          <WhatsAppButton />
        </body>
      </html>
    </div>
  );
};

export default Home;
